/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
/* eslint-disable import/extensions */

import { memo, useContext } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { UserContext } from '@context/UserContext';

import {
  Avatar, MangoLevel, Badge, FollowButton,
} from '@shared/components';

// utils
import stringTruncate from '@shared/utils/StringTruncate';
import numberFormatter from '@shared/utils/NumberFormatter';
// styles
import './ProfileHeader.css';

function ProfileHeader({
  isMobile,
  isTablet,
  isExtraSmall,
  isLive,
  userNameLink,
  avatarImage,
  nickName,
  streamTitle,
  userName,
  userInfo,
  channelId,
}) {
  const { loggedIn } = useContext(UserContext);
  const userFollowObject = {
    guid: userInfo.guid,
    username: userInfo.username,
    avatar: userInfo.avatar,
    relation_status: userInfo.relation_status,
    user_status: userInfo.user_status,
    feed_id: channelId,
  };
  const enableProfileStream = process.env.REACT_APP_VIEW_PROFILE_STREAM;
  const getViewportSizeHeader = () => {
    if (isMobile || isTablet) return '100%';
    return '45vw';
  };

  const addWidthOnProfileInfo = () => {
    if (isMobile) return '50vw';
    if (isExtraSmall) return '45vw';
  };

  const truncateUserName = (name, size) => {
    if (isExtraSmall) return stringTruncate(name, size);
    return name;
  };
  const displayFollowButton = () => {
    if (userInfo.length !== 0 || userInfo !== undefined || userInfo !== null) {
      if (loggedIn.guid === userInfo.guid) return null;
      return <FollowButton data={userFollowObject} />;
    }
  };
  return (
    <Grid
      container
      item
      className='profile-header'
      style={{
        width: getViewportSizeHeader(),
      }}
      alignItems='center'
      lg={12}
      md={12}
    >
      <Avatar
        isLive={isLive}
        userNameLink={userNameLink}
        avatarImage={avatarImage}
      />
      <div
        className='profile-info-container'
        style={{
          width: addWidthOnProfileInfo(),
        }}
      >
        <Grid
          container
          alignItems='center'
          justifyContent='flex-start'
          className='profile-title-container'
        >
          <a href={userNameLink}>
            <Typography
              className='profile-title'
              variant='h1'
              style={{
                fontSize: isMobile ? '11pt' : '25px',
              }}
            >
              {isLive === 1 && enableProfileStream === 'true' && (
                truncateUserName(streamTitle, 10)
              )}
              {isLive !== 1 && (
                truncateUserName(nickName, 25)
              )}
            </Typography>
          </a>
        </Grid>
        <Grid
          container
          alignItems='center'
          justifyContent='flex-start'
        >
          <Grid item>
            <a
              href={userNameLink}
            >
              <Typography
                className='username-container'
                variant='h2'
                style={{
                  fontSize: `${isExtraSmall ? '13px' : '16px'}`,
                }}
              >
                @
                {truncateUserName(userName, 14)}
              </Typography>
            </a>
          </Grid>
          <Grid item>
            {userInfo.type === 1 && (
              <>
                                &nbsp;&nbsp;
                <Badge
                  type={userInfo.type}
                  tier={userInfo.tier}
                  tier_icon={userInfo.tier_icon}
                  width={isExtraSmall ? 15 : 22}
                />
              </>
            )}
            <MangoLevel
              level={userInfo.level}
              width={isExtraSmall ? 15 : 20}
            />
          </Grid>
        </Grid>
        <Grid
          container
          alignItems='center'
          justifyContent='flex-start'
        >
          <Typography
            style={{
              fontSize: isExtraSmall ? 13 : 16,
              fontFamily: 'CircularXX-Book',
            }}
          >
            {numberFormatter(userInfo.follower_number, 3)}
&nbsp;followers
          </Typography>
        </Grid>
      </div>
      {displayFollowButton()}
    </Grid>
  );
}

export default memo(ProfileHeader);
